import React, { FC } from 'react';
import DefaultArrow from 'assets/svgs/arrow.svg';
import { Styles } from './styles';

export type ArrowProps = {
  onClick: () => void;
  direction?: 'up' | 'down' | 'left' | 'right';
  color?: string;
  height?: string;
  width?: string;
  backgroundColor?: string;
  disabled?: boolean;
  hideWhenDisabled?: boolean;
};

export const Arrow: FC<ArrowProps> = ({
  onClick,
  direction,
  backgroundColor,
  disabled,
  width,
  height,
}) => {
  return (
    <Styles.Button
      disabled={disabled}
      backgroundColor={backgroundColor}
      direction={direction}
      width={width}
      height={height}
      onClick={onClick}
    >
      <DefaultArrow />
    </Styles.Button>
  );
};
